"use client";
import LazyFooterImage from "@/components/footer/LazyFooterImage";
import { Separator } from "@/components/ui/separator";

import bitcoin from "@/public/img/footer/bitcoin.webp";
import visa from "@/public/img/footer/visaM.png";
import pybam from "@/public/img/v2/deposit/icons/pybam.svg";
import pybi from "@/public/img/v2/deposit/icons/pybi.png";
import ikisi from "@/public/img/v2/deposit/icons/pyikisi.png";
import super24 from "@/public/img/v2/deposit/icons/pysuper24.png";
import midas from "@/public/img/v2/deposit/icons/midasRd.png";
import popular from "@/public/img/v2/deposit/icons/popularRd.png";
import { useAuth } from "@/core/auth/client/AuthProvider";
import { useEffect, useState } from "react";

const LazySponsors = () => {
  const { session } = useAuth();
  const [isCurrency, setIsCurrency] = useState<string | undefined | null>(null);
  useEffect(() => {
    setIsCurrency(session?.user?.currency);
  }, [session?.user?.currency]);

  return (
    <>
      <div className="flex flex-row flex-wrap justify-evenly items-center my-4 gap-8">
        <LazyFooterImage
          src={visa}
          alt="Visa Master"
          width={50}
          height={30}
          className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
          priority={false}
        />
        <LazyFooterImage
          src={bitcoin}
          alt="Criptos"
          width={125}
          height={40}
          className="object-fill max-lg:max-w-[70px] lg:max-w-[100px]"
          priority={false}
        />
        {session && (
          <>
            {isCurrency === "GTQ" && (
              <>
                <LazyFooterImage
                  src={pybam}
                  alt="pybam"
                  width={110}
                  height={60}
                  className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
                  priority={false}
                />
                <LazyFooterImage
                  src={pybi}
                  alt="pybi"
                  width={110}
                  height={60}
                  className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
                  priority={false}
                />
                <LazyFooterImage
                  src={ikisi}
                  alt="ikisi"
                  width={110}
                  height={60}
                  className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
                  priority={false}
                />
                <LazyFooterImage
                  src={super24}
                  alt="Visa Master"
                  width={110}
                  height={60}
                  className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
                  priority={false}
                />
              </>
            )}
            {isCurrency === "DOP" && (
              <>
                <LazyFooterImage
                  src={midas}
                  alt="midas"
                  width={110}
                  height={60}
                  className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
                  priority={false}
                />
                <LazyFooterImage
                  src={popular}
                  alt="popular"
                  width={110}
                  height={60}
                  className="object-fill max-lg:max-w-[80px] lg:max-w-[100px]"
                  priority={false}
                />
              </>
            )}
          </>
        )}
      </div>
      <Separator className="bg-sivarbet-border my-4" />
      <h4 className="font-bold">Patrocinadores oficiales:</h4>
      <div className="flex flex-col items-center my-8 gap-5"></div>
    </>
  );
};

export default LazySponsors;
